import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { CompProps } from 'types'

interface Props {
  label: string
}

export const ContentSection = ({ children, label }: CompProps<Props>) => {
  const { colors } = useTheme()

  return (
    <div
      className={css`
        &:not(:last-child) {
          margin-bottom: 40px;
        }
      `}
    >
      <Text
        className={css`
          margin-bottom: 16px;
        `}
        type="subhead"
        sizing={{ base: 'XS', mobileL: 'S' }}
        color={colors.uiPewterGrey}
      >
        {label}
      </Text>
      {children}
    </div>
  )
}
